// extracted by mini-css-extract-plugin
export default {"address":"style_address__v0YVm","address1":"style_address1__++xtt","address2":"style_address2__iTJvf","city":"style_city__PJSEL","zip":"style_zip__aRoU8"};